'use client'

import { personalisedTabsMap } from 'fuelPageMock'
import Image from 'next/image'
import { trackEvent } from '@acko-tech/building-blocks.ui.acko-analytics'
import { FUEL_TAP_EVENTS } from '@constants/fuelEvents'
import { fuelSegmentEventCommonPropFunc } from '@utils/segmentProperties'
import styles from './getPersonalisedTabs.module.scss'
import { ARROW, GET_PERSONALISED } from './constants/texts'

const GetPersonalisedTabs = () => {
  const handlePersonalisedTabs = async (eventName, redirectionUrl, productType) => {
    const fuelSegmentCommonProperties = await fuelSegmentEventCommonPropFunc({ product: productType })
    await trackEvent(eventName, {
      ...fuelSegmentCommonProperties,
    })
      .then(() => {})
      .catch(err => {
        console.error(err)
      })
    window.open(redirectionUrl, '_blank')
  }
  return (
    <div className={styles.personalisedRootContainer}>
      <div className={styles.personalisedTitle}> {GET_PERSONALISED}</div>
      <div className={styles.personalisedUlTag}>
        {personalisedTabsMap.map((item, index) => (
          <div className={styles.personalisedLiTag} key={`${item?.type}${index}`}>
            <div
              className={styles.personalisedTabs}
              onClick={e => {
                e.preventDefault()
                void handlePersonalisedTabs(FUEL_TAP_EVENTS.TAP_PRODUCT_LINKS, item?.redirection_url, item.product)
              }}
              style={{ background: item.backgroundColor }}>
              <div className={styles.personalisedFirstIcon}>
                <Image height={18} width={35} src={item?.icon} alt={`${item.type} Icon`} layout="fixed" />
              </div>
              <div className={styles.personalisedSecondIcon} style={{ background: item.backgroundColor }}>
                {item.type}
              </div>
              <Image height={12} alt={`${item.type} Icon`} width={12} src={ARROW} layout="fixed" />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default GetPersonalisedTabs
